import React from "react";
import StatusBadge from "../../../UI/statusBadge";

const CuriorInfo = ({ name, phone, status, email, avg_rate, vehicle ,created_at }) => {
  const curiorInfo = [
    { title: "الإسم", value: name },
    { title: "   رقم الجوال", value: phone },
    { title: "الإيميل", value: email },
    { title: "نوع المركبة", value: vehicle.car_model },
    { title: " رقم اللوحة", value: vehicle.plate_number },
    { title: " تاريخ الإنضمام", value: created_at },

    { title: " التقييم", value: `${avg_rate} ⭐` },
  ];
  return (
    <div className="row">
      <h5 className="mb-3"> المعلومات الشخصية</h5>
      <div className="col-12">
        <ul className="two-columns">
          {curiorInfo.map((item, index) => (
            <li key={index}>
              <h4 className="font14 font700">{item.title}</h4>
              {item.title === "الحالة" ? (
                <StatusBadge status={status} />
              ) : (
                <p>{item.value}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CuriorInfo;
